import client from './client';

export const getRounds = async (gameId, params = {}) => {
  const response = await client.get(`/api/games/${gameId}/rounds`, { params });
  return response.data;
};

export const getCurrentRound = async (gameId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/current`);
  return response.data;
};

export const getRound = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}`);
  return response.data;
};

export const createRound = async (gameId, roundData) => {
  const response = await client.post(`/api/games/${gameId}/rounds`, roundData);
  return response.data;
};

export const setRoundPrompt = async (gameId, roundId, promptData) => {
  const response = await client.put(`/api/games/${gameId}/rounds/${roundId}/prompt`, promptData);
  return response.data;
};

/**
 * Update round settings (GM only, setup phase only)
 * @param {string} gameId
 * @param {string} roundId
 * @param {Object} settings - { passageLength?, prompt? }
 */
export const updateRoundSettings = async (gameId, roundId, settings) => {
  const response = await client.put(`/api/games/${gameId}/rounds/${roundId}/settings`, settings);
  return response.data;
};

export const advanceRound = async (gameId, roundId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/advance`);
  return response.data;
};

export const addRoundAspect = async (gameId, roundId, aspectData) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/aspects`, aspectData);
  return response.data;
};

/**
 * Complete the round - distribute pot and calculate MVP (GM only)
 */
export const completeRound = async (gameId, roundId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/complete`);
  return response.data;
};

/**
 * Award GM Pick bonus to a player (GM only)
 */
export const awardGMPick = async (gameId, roundId, userId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/gm-pick`, { userId });
  return response.data;
};

/**
 * Get round results (votes, MVP, distribution, GM pick)
 */
export const getRoundResults = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/results`);
  return response.data;
};

/**
 * Toggle player ready status during influence phase
 */
export const togglePlayerReady = async (gameId, roundId) => {
  const response = await client.post(`/api/games/${gameId}/rounds/${roundId}/toggle-ready`);
  return response.data;
};

/**
 * Get ready status for all players during influence phase
 */
export const getReadyStatus = async (gameId, roundId) => {
  const response = await client.get(`/api/games/${gameId}/rounds/${roundId}/ready-status`);
  return response.data;
};
